import React, {memo} from "react"
import { Handle, Position } from "@xyflow/react"
import Tooltip from "../Tooltip"
import {SECTION_COLOR, STEP_TEXT_COLOR, STEP_TEXT_OTHER_DAY_COLOR} from "../FlowPage"
import { PSE_FLOWS_OPTIONS } from "../../../utils/productionStepExecution"
import { Typography } from "@mui/material"

const sx = {
    label: {
        color: "#262626",
        fontSize: 16,
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px"
    }
}

export default memo(({data, onClick}) => {
    const size = data.size
    const width = size?.width || 200
    const height = size?.height || 60

    // Safety check: fallback to TODO status if status is undefined
    const statusConfig = PSE_FLOWS_OPTIONS[data.status] || PSE_FLOWS_OPTIONS.TODO || {
        color: "#BBDEFB",
        label: "Unknown",
        icon: "todo"
    }

    return (
        <Tooltip id={data.id}>
            <div
                className="flexRow center"
                style={{
                    position: "relative", // for the handle to be positioned correctly
                    width,
                    height,
                    paddingLeft: 8,
                    fontSize: "16px",
                    borderRadius: 4,
                    padding: "16px 12px 16px 8px",
                    gap: "8px",
                    color: data.sameDay ? STEP_TEXT_COLOR : STEP_TEXT_OTHER_DAY_COLOR,
                    backgroundColor: statusConfig.color,

                }}
                onClick={onClick}
            >
                <div className="flexColumn center justifyCenter">
                    <img alt={statusConfig.label} src={"/icons/pses/status/" + statusConfig.icon + ".svg"} style={{ width: "16px", height: "16px" }} />
                </div>
                <div className="flexRow">
                    {data.isReprod && (
                        <div className="flexRow justifyCenter" style={{
                            width: 24, height: 24,
                            borderRadius: "50%", backgroundColor: SECTION_COLOR,
                            paddingRight: 1,
                            marginRight: 8,
                            color: "white"
                        }}>R</div>
                    )}
                    <Typography sx={sx.label}>{data.label}</Typography>
                </div>
                {/* Handles for edges */}
                {data.level >= 1 && <Handle type="target" position={Position.Left} id="left"/>}
                <Handle type="source" position={Position.Right} id="right"/>
            </div>
        </Tooltip>
    )
})
